import { Modal, Button, Checkbox } from "antd";
import React from "react";

import "./styles.css";

const CheckboxGroup = Checkbox.Group;

const ChooseOutletDialog = ({
  title,
  visible,
  handleSave,
  handleCancel,
  data,
  onCheckAllChange,
  onSingleChange,
  indeterminate,
  outletCheckAll,
  outletCheckedList,
}) => {
  return (
    <Modal
      className="modal-outlet"
      title={title}
      visible={visible}
      onOk={handleSave}
      onCancel={handleCancel}
      width={"25%"}
      centered
      footer={[
        <Button
          key="back"
          onClick={handleCancel}
          className="btn-modal btn-default"
        >
          Kembali
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSave}
          className="btn-modal"
        >
          Simpan
        </Button>,
      ]}
    >
      <Checkbox
        className="outlet-all-checkbox"
        checked={outletCheckAll}
        onChange={onCheckAllChange}
        indeterminate={indeterminate}
      >
        Tampilkan Semua Outlet
      </Checkbox>
      <CheckboxGroup
        className="outlet-group-checkbox"
        options={data}
        value={outletCheckedList}
        onChange={onSingleChange}
      />
    </Modal>
  );
};

export default ChooseOutletDialog;
